import { OverlayModule } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import { booleanAttribute, Component, forwardRef, input, model, viewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClickOutsideDirective } from '@ss/shared/click-outside';

export interface SelectWithDescriptionOption {
	displayName: string;
	description: string;
}

@Component({
	selector: 'ss-select-with-description',
	templateUrl: './select-with-description.component.html',
	styleUrls: ['./select-with-description.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => SelectWithDescriptionComponent),
			multi: true,
		}
	],
	imports: [
		MatFormFieldModule,
		MatInputModule,
		MatIconModule,
		OverlayModule,
		ClickOutsideDirective,
		FormsModule,
		MatTooltipModule,
		NgClass
	]
})
export class SelectWithDescriptionComponent implements ControlValueAccessor {
	inputField = viewChild<NgModel>('inputField');

	isOpen = false;

	disabled = model<boolean>(false);

	disabledMessage = input('');

	value: any;

	options = input.required<SelectWithDescriptionOption[]>();

	label = input.required<string>();

	required = input(false, { transform: booleanAttribute });

	subscriptSizing = input<'fixed' | 'dynamic'>('fixed');

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	onChange: (value) => void = () => {};

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	onTouched: () => void = () => {};

	toggleDropdown(): void {
		if (!this.disabled()) {
			this.isOpen = !this.isOpen;
		}
	}

	selectOption(option: SelectWithDescriptionOption): void {
		this.value = option;
		this.isOpen = false;
		this.onChange(option);
		this.onTouched();
	}

	writeValue(value: SelectWithDescriptionOption): void {
		this.value = value || null;
	}

	registerOnChange(fn: (value: SelectWithDescriptionOption | null) => void): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	setDisabledState?(isDisabled: boolean): void {
		this.disabled.set(isDisabled);
	}
}
